import React from 'react';
import styles from './categoryCardCollapsibleSkeleton.module.scss';
import Selectors from 'src/utils/selectors';
import SkeletonLoader from 'src/components/atomic/atoms/skeletonLoader/SkeletonLoader';
import ShowSubcategoryButton from 'src/components/atomic/molecules/showSubcategoryButton/ShowSubcategoryButton';

export default function CategoryCardCollapsibleSkeleton(): JSX.Element {
    return (
        <div
            className={styles.categoryCardCollapsibleSkeleton}
            data-cy={Selectors.SpendSmart.CATEGORY_CARD_COLLAPSIBLE_SKELETON}
        >
            <div className={styles.skeletonTop}>
                <div className={styles.skeletonLeft}>
                    <SkeletonLoader />
                    <div>
                        <SkeletonLoader />
                        <SkeletonLoader />
                    </div>
                </div>
                <div className={styles.skeletonRight}>
                    <SkeletonLoader />
                    <SkeletonLoader />
                </div>
            </div>
            <div className={styles.skeletonBottom}>
                <ShowSubcategoryButton disabled />
            </div>
        </div>
    );
}
